import { gql } from 'urql';

const FetchFlexPayOverTimeIntroDetails = gql`
  query FetchFlexPayOverTimeIntroDetails {
    flexPayOverTimeIntroDetails {
      __typename
      ... on FlexPayOverTimeIntroDetailsSuccess {
        details
        purchasingPowerAmount {
          amount
          currency
          formatted
          formattedWithPlusPrefix
          formattedWithPlusPrefixOrAbs
        }
      }
      ... on FlexPayOverTimeIntroNoneSuccess {
        summary
        purchasingPowerAmount {
          amount
          currency
          formatted
          formattedWithPlusPrefix
          formattedWithPlusPrefixOrAbs
        }
      }
      ... on FlexPayOverTimeIntroError {
        code
        title
        message
      }
    }
  }
`;

export default FetchFlexPayOverTimeIntroDetails;
